var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"m-2 p-2 border border-red-400 px-3 bg-red-100 rounded-lg text-red-700",on:{"click":function($event){return _vm.undo(_vm.item)}}},[_vm._v("Reset Data & Type")])])}
var staticRenderFns = []

export { render, staticRenderFns }